import {
  emptySsnFullMask,
  emptySsnLast4Mask,
  emptySsnLast6Mask,
  ssnFullMask,
  ssnLast4Mask,
  ssnLast6Mask,
} from '../../constants/masks';
import { ssnRegExpFull, ssnRegExpLast4Min, ssnRegExpLast6Min } from '../../utils/validation/ssn';

export const SsnTypes = {
  Full: 'SSN',
  Last4: 'SSN_LAST_4',
  Last6: 'SSN_LAST_6',
} as const;

export type SsnType = typeof SsnTypes[keyof typeof SsnTypes];

export const ssnDetailMap: {
  [key in SsnType]: { mask: string; label: string; emptyMask: string; regExp: RegExp };
} = {
  [SsnTypes.Full]: {
    mask: ssnFullMask,
    label: 'SSN',
    emptyMask: emptySsnFullMask,
    regExp: ssnRegExpFull,
  },
  [SsnTypes.Last4]: {
    mask: ssnLast4Mask,
    label: 'Last 4 Of SSN',
    emptyMask: emptySsnLast4Mask,
    regExp: ssnRegExpLast4Min,
  },
  [SsnTypes.Last6]: {
    mask: ssnLast6Mask,
    label: 'Last 6 Of SSN',
    emptyMask: emptySsnLast6Mask,
    regExp: ssnRegExpLast6Min,
  },
};

export const getSsnDetails = (ssnType?: SsnType) => {
  if (!ssnType) {
    return ssnDetailMap[SsnTypes.Full];
  }

  return ssnDetailMap[ssnType] || ssnDetailMap[SsnTypes.Full];
};
